"use client";

import { baseApi } from "./baseApi";

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credential: {
        agent_email_or_username: string;
        agent_password: string;
      }) => ({
        url: "/authentication/agentLogin",
        method: "POST",
        body: credential,
      }),
    }),

    /**
     * Single sign-on: exchange a token minted by the host site for a dashboard
     * session, so an agent already signed in to the customer's own panel does
     * not log in a second time.
     *
     * The token comes from one of two places, and the gateway accepts either:
     * the host site asks us to mint one with the OAuth credentials it already
     * has (POST /api/external/sso/ticket), or it signs one itself with the
     * company's `tenant_secret`. Both are short-lived and single-use — an agent
     * session grants access to every conversation, so unlike the widget's
     * visitor flow a non-expiring identity hash is not acceptable here.
     * Contract: docs/agent-sso.md.
     *
     * Responds with the same agent payload as agentLogin, plus `msrp_ha1`: the
     * stored `h1_<md5hex>` digest credential that lets the SCont handshake run
     * without the user's password ever reaching the browser.
     */
    ssoLogin: builder.mutation({
      query: (payload: { token: string }) => ({
        url: "/authentication/agentSsoLogin",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useLoginMutation, useSsoLoginMutation } = authApi;
